import Calculation from '../../../types/api/calculation'
import CalculationPosition from '../../../types/api/calculation-position'

export default function isCalculation(
    data: Calculation | CalculationPosition
): data is Calculation {
    return 'client' in data
}
